import {
  aMatchListItem,
  anAddItemToMatchList,
  anItemMeta,
  mockAddMatchListItemOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const addMatchListItemHandler = ({
  id,
  value,
  description,
  expiration,
}) => ({
  __typename: 'Mutation',
  addItemToMatchList: anAddItemToMatchList({
    finishedProcessing: true,
    data: aMatchListItem({
      id,
      value,
      expiration,
      meta: anItemMeta({ description }),
    }),
  }),
});

export const handlers = [
  mockAddMatchListItemOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          addItemToMatchList: anAddItemToMatchList({
            finishedProcessing: true,
          }),
        },
      });
    }
  ),
];
